module.exports = __webpack_public_path__ + "static/media/asahi_logo.6ec59bec.png";